import {
  Box,
  Input,
  Text,
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  FormControl,
  Select,
  Divider,
  Checkbox
} from "@chakra-ui/react";
import { theme } from "../../../styles/theme";
import { InputMask } from '../../../components/InputMask'

export function Form({isOpen, onClose, user, handleProfileChange, handleEditUser, states, cities, handleLocality, mapedCitiesForState, profile, handleFileChange, userPhoto, setUserDocument, userDocument, setUserPhoneNumber, userPhoneNumber, errors}) {
  function handleTogglePasswordVisibility(e) {
    e.preventDefault();
    const passwordInput = document.getElementById('password')
    if (e.target.checked) {
      passwordInput.type = "text"
    } else {
      passwordInput.type = "password"
    }
  }
  return (
    <Modal isOpen={isOpen} onClose={onClose} overlayStyle={{ backgroundColor: `${theme.colors.whiteSmoke}` }}>
      <ModalOverlay />
      <ModalContent
        bg="white"
        borderRadius="24px"
        overflow="hidden"
        maxW="720px"
        mx="16px"
        boxShadow="0 20px 50px rgba(0,0,0,.12)"
      >
        <ModalHeader
          bg={`
            linear-gradient(
              135deg,
              ${theme.colors.primaryGreen} 0%,
              #00553b 100%
            )
          `}
          color="white"
          py="20px"
        >
          <Text
            fontSize="24px"
            fontWeight="900"
          >
            Editar Perfil
          </Text>

          <Text
            fontSize="14px"
            opacity=".8"
            mt="4px"
          >
            Atualize suas informações pessoais
          </Text>
        </ModalHeader>

        <ModalCloseButton
          color="white"
          _hover={{
            bg: "rgba(255,255,255,.12)"
          }}
        />
        <Divider py="5px"/>
        <ModalBody>
          <FormControl encType="multipart/form-data">
            {/* <Text>Email</Text>
            <Input borderColor={theme.colors.lightGray} _hover={{borderColor: theme.colors.lightGray}} name="email" value={profile?.email} onChange={handleProfileChange}></Input> */}
            <FormControl mb="16px">
              <Text mb="6px" fontWeight="600">
                Email
              </Text>

              <Input
                h="52px"
                borderRadius="14px"
                borderColor="#E2E8F0"
                name="email"
                value={profile?.email}
                onChange={handleProfileChange}
              />
            </FormControl>
            {/* <Text marginTop="10px">Senha</Text>
            <Input id="password" borderColor={theme.colors.lightGray} _hover={{borderColor: theme.colors.lightGray}} type="password" name="password" value={profile?.password} onChange={handleProfileChange}></Input> */}
            <FormControl mb="8px">
              <Text mb="6px" fontWeight="600">
                Senha
              </Text>

              <Input
                id="password"
                type="password"
                h="52px"
                borderRadius="14px"
                borderColor="#E2E8F0"
                name="password"
                value={profile?.password}
                onChange={handleProfileChange}
              />
            </FormControl>
            <Checkbox onChange={(e) => handleTogglePasswordVisibility(e)} textAlign={"left"} marginTop={"5px"}>Mostrar senha?</Checkbox>

            <Divider my="24px" />

            <Text
              fontSize="13px"
              fontWeight="800"
              color={theme.colors.primaryGreen}
              textTransform="uppercase"
              mb="12px"
            >
              Dados pessoais
            </Text>
            {/* <Text marginTop="10px">Nome</Text>
            <Input borderColor={theme.colors.lightGray} _hover={{borderColor: theme.colors.lightGray}} name="full_name" value={profile?.full_name} onChange={handleProfileChange}></Input> */}
            <FormControl mb="16px">
              <Text mb="6px" fontWeight="600">
                Nome completo
              </Text>

              <Input
                h="52px"
                borderRadius="14px"
                borderColor="#E2E8F0"
                name="full_name"
                value={profile?.full_name}
                onChange={handleProfileChange}
              />
            </FormControl>
            {errors.full_name && <Text color="red.500" fontSize="sm">{errors.full_name[0]}</Text>}
            <Box
              display="grid"
              gridTemplateColumns={{
                base: "1fr",
                md: "1fr 1fr"
              }}
              gap="16px"
            >
              {/* <Box>
                <Text marginTop="10px">CPF</Text>
                <InputMask maskType="cpf" placeholder="CPF" setUserDocument={setUserDocument} value={userDocument} onChange={(e) => setUserDocument(e.target.value)}/>
              </Box> */}
              <Box>
                <Text mb="6px" fontWeight="600">
                  CPF
                </Text>

                <InputMask
                  maskType="cpf"
                  placeholder="000.000.000-00"
                  value={userDocument}
                  setUserDocument={setUserDocument}
                  onChange={(e) =>
                    setUserDocument(e.target.value)
                  }
                />
              </Box>
              {errors.document_number && <Text color="red.500" fontSize="sm">{errors.document_number[0]}</Text>}
              {/* <Box>
                <Text marginTop="10px">Celular</Text>
                <InputMask maskType="phone" placeholder="(99) 99999-9999" name="phone_number" value={userPhoneNumber} setUserPhoneNumber={setUserPhoneNumber} onChange={(e) => setUserPhoneNumber(e.target.value)}/>
              </Box> */}
              <Box>
                <Text mb="6px" fontWeight="600">
                  Celular
                </Text>

                <InputMask
                  maskType="phone"
                  placeholder="(31) 99999-9999"
                  value={userPhoneNumber}
                  setUserPhoneNumber={setUserPhoneNumber}
                  onChange={(e) =>
                    setUserPhoneNumber(e.target.value)
                  }
                />
              </Box>
            </Box>
            <Divider my="24px" />

            <Text
              fontSize="13px"
              fontWeight="800"
              color={theme.colors.primaryGreen}
              textTransform="uppercase"
              mb="12px"
            >
              Endereço
            </Text>
            <Box>
              <Text marginTop="10px">Logradouro</Text>
              {/* <Input borderColor={theme.colors.lightGray} _hover={{borderColor: theme.colors.lightGray}} name="address_street" value={profile?.address_street} onChange={handleProfileChange}></Input> */}
              <Input
                h="52px"
                borderRadius="14px"
                mb="16px"
                name="address_street"
                value={profile?.address_street}
                onChange={handleProfileChange}
              />
            </Box>
            <Box
              display="grid"
              gridTemplateColumns={{
                base: "1fr",
                md: "120px 1fr"
              }}
              gap="16px"
              mb="16px"
            >
              <Box>
                <Text>Nº</Text>
                <Input borderColor={theme.colors.lightGray} _hover={{borderColor: theme.colors.lightGray}} name="address_number" value={profile?.address_number} onChange={handleProfileChange}></Input>
              </Box>
              <Box>
                <Text>Complemento</Text>
                <Input borderColor={theme.colors.lightGray} _hover={{borderColor: theme.colors.lightGray}} name="address_complement" value={profile?.address_complement} onChange={handleProfileChange}></Input>
              </Box>
            </Box>
            <Box
              display={"flex"}
              gap={"10px"}
              marginTop="10px"
            >
              <Box>
                <Text>Bairro</Text>
                <Input borderColor={theme.colors.lightGray} _hover={{borderColor: theme.colors.lightGray}} name="address_neighborhood" value={profile?.address_neighborhood} onChange={handleProfileChange}></Input>
              </Box>
              <Box>
                <Text>CEP</Text>
                <Input borderColor={theme.colors.lightGray} _hover={{borderColor: theme.colors.lightGray}} name="address_postal_code" value={profile?.address_postal_code} onChange={handleProfileChange}></Input>
              </Box>
            </Box>
            <Box
              display="grid"
              gridTemplateColumns={{
                base: "1fr",
                md: "1fr 1fr"
              }}
              gap="16px"
            >
              <Box>
                <Text >Estado</Text>
                <Select
                  name="state_id"
                  id="state_input"
                  width="100%"
                  value={profile?.state_id || ""}
                  onChange={(e) => {
                    handleProfileChange(e);
                    handleLocality(e);
                  }}
                  borderColor={theme.colors.lightGray} _hover={{borderColor: theme.colors.lightGray}}
                >
                  <option value=""></option>
                  {states.map((state) => (
                    <option key={state.id} value={state.id}>
                      {state.name}
                    </option>
                  ))}
                </Select>
              </Box>
              {(mapedCitiesForState.length > 0) && (
                <Box>
                  <Text>Cidade</Text>
                  <Select
                    name="city_id"
                    value={profile?.city_id || ""}
                    width="100%"

                    onChange={handleProfileChange}
                    borderColor={theme.colors.lightGray} _hover={{borderColor: theme.colors.lightGray}}
                  >
                    {mapedCitiesForState.map((city) => (
                      <option key={city.id} value={city.id}>
                        {city.name}
                      </option>
                    ))}
                  </Select>
                </Box>
              )}
            </Box>
            <Input type="file" id="userPhoto" onChange={handleFileChange} name="photo" multiple={false} marginTop='20px' border='none' display="none"/>
            <label htmlFor="userPhoto">
              <Button
                as="label"
                htmlFor="userPhoto"
                variant="outline"
                borderRadius="14px"
                borderColor={theme.colors.primaryOrange}
                color={theme.colors.primaryOrange}
                mt="24px"
                cursor="pointer"
                _hover={{
                  bg: theme.colors.primaryOrange,
                  color: "white"
                }}
              >
                Escolher Foto
              </Button>
              {userPhoto && (
                <span>{userPhoto.name}</span>
              )}
            </label>
          </FormControl>
        </ModalBody>
        <ModalFooter
          borderTop="1px solid #edf2f7"
          py="20px"
        >
          <Button
            mr="12px"
            variant="ghost"
            onClick={onClose}
          >
            Cancelar
          </Button>

          <Button
            flex="1"
            h="52px"
            borderRadius="16px"
            bg={theme.colors.primaryGreen}
            color={theme.colors.primaryOrange}
            fontWeight="900"
            _hover={{
              bg: "#00553b"
            }}
            onClick={(e) => handleEditUser(e)}
          >
            Salvar Alterações
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}
